// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1L4eI","description":"PatientConsentPreview_description__2Og95"};